import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../storage/contexts/UserContext";
import FilledButton from "../InterstellrComponents/FilledButton";

const DailyCheckInSuccessModal = ({ isOpen, onClose, onUndo }) => {
  const { profile } = useContext(UserContext);
  const navigate = useNavigate();

  const handleSubmit = (value) => {
    if (onSubmit) {
      onSubmit(value); // Call the provided onSubmit function with the value
    }
    onClose(); // Close the modal
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300">
      <div className="bg-white rounded-lg w-full max-w-md mx-4 p-6 shadow-xl transform transition-all duration-300 scale-100">
        <div className="flex flex-col items-center">
          <h4 className="text-lg font-semibold text-center mb-2">
            Mood Captured
          </h4>

          <p className="text-base font-normal text-black mb-4">
            Thank you for checking-in today {profile?.firstname ?? ""}
          </p>

          <FilledButton
            text={"Okay"}
            marginBottom={8}
            onPress={() => {
              onClose();
              navigate("/dashboard");
            }}
          />

          <FilledButton
            text={"Head to Wellness"}
            backgroundColor={"#2B2744"}
            onPress={() => {
              onClose();
              navigate("/wellness");
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DailyCheckInSuccessModal;
